import { AccountType, AccountPath } from "../mapper/enums/accountType";

export function getAccountTypeName(accountType) {
  switch (accountType) {
    case AccountType.USER:
      return "USER";
    case AccountType.SUPER_ADMIN:
      return "SUPER_ADMIN";
    case AccountType.SYSTEM_ADMIN:
      return "SYSTEM_ADMIN";
    default:
      return "SYSTEM_ADMIN";
  }
}

export function getAccountPathByName(name) {
  switch (name) {
    case "USER":
      return AccountPath.USER;
    case "SYSTEM_ADMIN":
      return AccountPath.SYSTEM_ADMIN;
    case "SUPER_ADMIN":
      return AccountPath.SUPER_ADMIN;
    default:
      return AccountPath.SYSTEM_ADMIN;
  }
}

export function getRole(role) {
  switch (role) {
  }
}
